import { render } from "./PayImageGalleryEditModal.vue?vue&type=template&id=13cd8f82&scoped=true"
import script from "./PayImageGalleryEditModal.vue?vue&type=script&lang=js"
export * from "./PayImageGalleryEditModal.vue?vue&type=script&lang=js"

import "./PayImageGalleryEditModal.vue?vue&type=style&index=0&id=13cd8f82&scoped=true&lang=less"
import "./PayImageGalleryEditModal.vue?vue&type=style&index=1&id=13cd8f82&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13cd8f82"]])

export default __exports__